import { getConfig } from './configuration';
import formatInternal from './utils/format';
export const LEVELS = ['debug', 'info', 'warn', 'error'];
export const shouldLogLevel = level => {
  const configLevel = getConfig('level');
  if (configLevel === 'all') {
    return true;
  }
  if (LEVELS.includes(configLevel)) {
    return LEVELS.indexOf(level) >= LEVELS.indexOf(configLevel);
  }
  console.warn(formatInternal(`The log level "${level}" is not valid`));
  return false;
};